import { PageMeta } from "../app/PageMeta";
import { Footer } from "../components/Footer/Footer";
import { Header } from "../components/Header/Header";
import { siteConfig } from "../content/site";

export function PrivacyPage() {
  return (
    <>
      <PageMeta
        title="プライバシーポリシー｜松島オート"
        description="松島オートのウェブサイトにおける個人情報と外部サービスの取り扱いについてご案内します。"
      />
      <Header />
      <main id="main-content" className="privacy-page" tabIndex={-1}>
        <div className="section-shell privacy-page__inner">
          <p className="section-kicker">Privacy Policy</p>
          <h1>プライバシーポリシー</h1>
          <p className="privacy-page__lead">
            {siteConfig.businessName}
            は、このウェブサイトと電話でのお問い合わせに関する情報を、以下の方針で取り扱います。
          </p>

          <section
            aria-labelledby="privacy-contact"
            data-auth-signature="matsushima-contact-boundary"
          >
            <h2 id="privacy-contact">電話でお伝えいただく情報</h2>
            <p>
              お電話でお伝えいただいた車種・年式・車両状態・所在市町村などの情報は、
              査定、引き取りのご相談と、そのために必要なご連絡に使用します。
              このウェブサイトには問い合わせフォームを設置していません。
            </p>
          </section>

          <section aria-labelledby="privacy-analytics">
            <h2 id="privacy-analytics">アクセス解析・広告について</h2>
            <p>
              現時点で、このウェブサイトにはアクセス解析、広告配信、
              サイト独自の問い合わせフォームを導入していません。
              将来導入する場合は、実際の利用内容に合わせてこのページを更新します。
            </p>
          </section>

          <section aria-labelledby="privacy-external">
            <h2 id="privacy-external">Google Mapsなどの外部サービス</h2>
            <p>
              店舗所在地の確認のため、Google Mapsの地図表示と外部リンクを使用しています。
              地図を表示したときやリンクを開いたときは、ブラウザからGoogleへ接続され、
              情報の取り扱いには同社の方針が適用されます。
            </p>
          </section>

          <section aria-labelledby="privacy-contact-point">
            <h2 id="privacy-contact-point">この方針についてのお問い合わせ</h2>
            <p>
              内容についてのお問い合わせは、
              <a href={siteConfig.phoneHref}>{siteConfig.phoneDisplay}</a>
              までお電話ください。{siteConfig.contactNote}、{siteConfig.closedDay}です。
            </p>
          </section>

          <p className="privacy-page__updated">制定：2026年7月18日</p>
        </div>
      </main>
      <Footer />
    </>
  );
}
